import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UrlService } from './url.service';
import { OfficialCategoriesByProtocolDto } from 'app/@types/dto/official-categories-by-protocol-dto.model';

@Injectable({
    providedIn: 'root',
})
export class OfficialCategoriesHttpService {
    constructor(
        private http: HttpClient,
        private urlService: UrlService,
    ) {}

    getAllOfficialCategories(locale?: string): Observable<OfficialCategoriesByProtocolDto> {
        return this.http.get<OfficialCategoriesByProtocolDto>(this.urlService.getOfficialCategories(locale));
    }
}
